import React, { useEffect, useRef } from 'react';
import { trackEvent } from '../../modules/analytics';

const YouTubePlayer = ({ videoId, autoPlay }) => {
    const playerRef = useRef(null);

    useEffect(() => {
        let player;

        const loadPlayer = () => {
            const YT = window.YT;
            if (!YT || !YT.Player) return;

            player = new YT.Player(playerRef.current, {
                videoId: videoId,
                events: {
                    onReady: onPlayerReady,
                    onStateChange: onPlayerStateChange
                }
            });
        };

        if (typeof window !== 'undefined') {
            if (window.YT && window.YT.Player) {
                loadPlayer();
            } else {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                window.onYouTubeIframeAPIReady = loadPlayer;
            }
        }

        return () => {
            if (player) {
                player.destroy();
            }
        };
    }, [videoId]);

    const onPlayerReady = (event) => {
        if (autoPlay) {
            event.target.playVideo();
        }
    };

    const onPlayerStateChange = (event) => {
        if (event.data === window.YT.PlayerState.PLAYING) {
            trackEvent('cta_video_play')
        }
    };

    return (
      <div
        ref={playerRef}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      ></div>
    );
};

export default YouTubePlayer;
